import microuniversoApi from "app/api/microuniversoApi"
import { atualizarItemAction, sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { IOrcamento } from "app/types/IOrcamento"
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'
import { WindowMU } from "app/types/WindowMU"
import * as atualizacaoItensOrcamentoLegadoActions from 'app/redux/atualizacaoItensOrcamentoLegadoSlice'


declare var window:WindowMU

export type DefinirDescontoAcumuladoSobreMercadoriasNacionais = {
    valorDesconto: number
}

export async function definirValorDescontoAcumuladoSobreMercadoriasNacionais(input: DefinirDescontoAcumuladoSobreMercadoriasNacionais) {

    const orcamentoAtualizado = await microuniversoApi.Orcamento.DefinirValorDescontoAcumuladoSobreMercadoriasNacionais(
        store.getState().orcamento.IdentificadorOrcamento,
        input.valorDesconto
    )

    const atualizarEstado = () => {
        const orcamentoLegado = window.orcamentoController.model
        orcamentoLegado.atualizar(orcamentoAtualizado, true, true,true)

        const atualizarEstadoItensLegado = () => {
            //const itensLegado = orcamentoLegado.get('ItensOrcamento')

            for(let itemAtualizado of (orcamentoAtualizado.ItensOrcamento ?? [])) {
                //const itemLegado = itensLegado.models.find(i => i.get('Identificador') == itemAtualizado.Identificador)
                //itemLegado.atualizar(itemAtualizado,true,true,true)

                store.dispatch(atualizacaoItensOrcamentoLegadoActions.atualizarItem({
                    identificador: itemAtualizado.Identificador,
                    dadosItem: itemAtualizado
                }))
            }
        }

        atualizarEstadoItensLegado()
    }


    atualizarEstado()
}
